module.exports = __webpack_public_path__ + "media/images/landing/dno/a-dbacedbc0c8815d48a585879d3c66cf5.png";